import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { UPDATE_INTEGRATION_DATA, UPDATE_INTEGRATION_DATA_SUCCESS, UPDATE_INTEGRATION_DATA_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* updateIntegrationData({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/data-integration`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPDATE_INTEGRATION_DATA_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_INTEGRATION_DATA_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_INTEGRATION_DATA_ERROR, payload: error });
  }
}

export function* watchUpdateIntegrationData() {
  yield takeEvery(UPDATE_INTEGRATION_DATA, updateIntegrationData);
}

function* updateIntegrationDataSaga() {
  yield all([fork(watchUpdateIntegrationData)]);
}

export default updateIntegrationDataSaga;
